export interface TubeData {
  id: string;
  color: string;
  thickness: number;
  intensity: number;
  /** Warm-white core tint (true) vs neutral white (false). Defaults false. */
  warm?: boolean;
  points: [number, number, number][];
}

export interface LightingSettings {
  /** Ambient fill on the wall + electrodes. Tubes are unlit and don't react. */
  ambient: number;
  /** Cool-blue directional key from upper-left, again wall-only. */
  rim: number;
}

export const DEFAULT_LIGHTING: LightingSettings = {
  ambient: 0.4,
  rim: 0.5,
};

export interface DesignData {
  version: 1;
  name: string;
  background: string;
  /** Backdrop style id. Defaults to "brick". */
  backdrop?: string;
  /** Scene-wide lighting; falls back to DEFAULT_LIGHTING when absent. */
  lighting?: LightingSettings;
  tubes: TubeData[];
}

export const DEFAULT_THICKNESS = 0.14;
export const DEFAULT_INTENSITY = 1.4;
export const DEFAULT_COLOR = "#ff2bd6";

/** A real-world neon-gas mapping for each preset color. Surfaces in tooltips. */
export interface PaletteEntry {
  hex: string;
  name: string;
}

export const NEON_PALETTE: PaletteEntry[] = [
  { hex: "#ff2bd6", name: "Mercury + magenta phosphor" },
  { hex: "#ff3b5c", name: "Neon + ruby phosphor" },
  { hex: "#ff8a2a", name: "Neon (red-orange)" },
  { hex: "#ffd93b", name: "Helium" },
  { hex: "#42ff8b", name: "Mercury + green phosphor" },
  { hex: "#2affea", name: "Argon + mercury (cool blue)" },
  { hex: "#3b7bff", name: "Argon" },
  { hex: "#b347ff", name: "Krypton" },
  { hex: "#ffffff", name: "White phosphor" },
  { hex: "#ff9ed0", name: "Pink phosphor" },
  { hex: "#7fffaa", name: "Pastel green phosphor" },
  { hex: "#ffe39d", name: "Warm white phosphor" },
];

/** Bare hex array — kept as a convenience for code that just wants colors. */
export const NEON_PALETTE_HEX: string[] = NEON_PALETTE.map((p) => p.hex);
